import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import FormLeftContent from './form-left-content.md';
import FormRightContent from './form-right-content.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const FormWrapperComponent = makeShortcode("FormWrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <FormWrapperComponent slots="content" repeat="2" theme="lightest" className="Contact-Form" mdxType="FormWrapperComponent" />
    <FormLeftContent mdxType="FormLeftContent" />
    <FormRightContent mdxType="FormRightContent" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      